export default __webpack_public_path__ + "assets/70a47f8f4e60bd07a41a3f0421755188.jpeg";